import { render } from "./RepLabStatus1View.vue?vue&type=template&id=2e7d1c6e"
import script from "./RepLabStatus1View.vue?vue&type=script&lang=js"
export * from "./RepLabStatus1View.vue?vue&type=script&lang=js"

import "./RepLabStatus1View.vue?vue&type=style&index=0&id=2e7d1c6e&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__